import { X } from 'lucide-react';

function AttachmentItem({ attachment, onRemove }) {
  const handleRemove = (e) => {
    e.stopPropagation();
    onRemove(attachment.id);
  };

  if (attachment.type === 'image') {
    const previewUrl = attachment.preview || (attachment.file ? URL.createObjectURL(attachment.file) : null);

    return (
      <div className="relative h-[72px] w-[72px] shrink-0">
        <button
          onClick={handleRemove}
          className="absolute right-0 top-0 z-10 flex h-5 w-5 items-center justify-center rounded-full bg-black/50 text-white hover:bg-black/70"
          aria-label="Remove attachment"
        >
          <X className="h-3 w-3" />
        </button>
        <div className="absolute bottom-0 left-0 h-16 w-16 overflow-hidden rounded-lg border border-border">
          <img
            src={previewUrl}
            alt="Attachment"
            className="h-full w-full object-cover"
          />
        </div>
      </div>
    );
  }

  return null;
}

export default AttachmentItem;
